// START IMPORTS
import { AppConfig } from '@ltvco/refresh-lib/ctx';
import {
  FirstRecordSearch,
  RecordSearchDataWithType,
  getFirstRecordSearch,
} from '@ltvco/refresh-lib/utils';
import { useAccount } from '@ltvco/refresh-lib/v1';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useState, useEffect, useContext } from 'react';
// END IMPORTS

// START INTERFACES_AND_TYPES
type FirstRecordSearchData =
  | FirstRecordSearch
  | RecordSearchDataWithType
  | null;
// END INTERFACES_AND_TYPES

export const useFirstRecordSearch = () => {
  // START HOOKS_AND_QUERIES
  const { routingUtils } = useContext(AppConfig);
  const isInFirstPDFVariation = useFeatureIsOn('RFRSH-3379');
  const { data: account } = useAccount(true);
  // END HOOKS_AND_QUERIES

  // START STATE_MANAGEMENT
  const [firstRecordSearchData] = useState<FirstRecordSearchData>(
    getFirstRecordSearch(routingUtils)
  );
  const [showFirstTimePDFModal, setFirstTimePDFModal] = useState(false);
  // END STATE_MANAGEMENT

  // START DERIVED_DATA_AND_UTILS
  const hadFirstSearch = !!firstRecordSearchData;
  // END DERIVED_DATA_AND_UTILS

  // START EFFECTS
  useEffect(() => {
    if (!account) {
      return;
    }

    if (hadFirstSearch) {
      setFirstTimePDFModal(
        isInFirstPDFVariation &&
          !account?.account?.subscription_info?.subscription_features
            ?.pdf_access
      );
    }
  }, [account]);
  // END EFFECTS

  return {
    firstRecordSearchData,
    showFirstTimePDFModal,
  };
};
